import React, { FC, useEffect, useRef, useState } from 'react';
import ReactTooltip from 'react-tooltip';

import getUserColors from '../../../../../common/getUserColors';
import imageSources from '../../../../../constants/imageSources/imageSources';
import * as Styled from './styles';
import { IContent, IRemoteUser } from '../../../../../types/content';

interface Props {
    user: IRemoteUser | null;
    elmIdx: string;
    isRemoteSelected: boolean;
    content: IContent;
}

const RemoteUserOverlay: FC<Props> = ({ user, elmIdx, isRemoteSelected, content, children }) => {
    const overlayRef = useRef(null);
    const [elementSize, setElementSize] = useState({ width: null, height: null });
    useEffect(() => {
        if (overlayRef.current) {
            const { clientHeight: height, clientWidth: width } = overlayRef.current;
            setElementSize({ width, height });
        }
    }, [isRemoteSelected, content]);
    const showName = (elementSize.width > 200 && elementSize.height > 35) || elementSize.height > 140;
    const showStacked = elementSize.height > 60;
    const {
        overlayBackgroundColor,
        overlayBorderColor,
        overlayWaveColor,
        overlayTextBackgroundColor,
        overlayTextColor,
    } = getUserColors(user);

    // If anyone is inside BTag offices or using VPN and logged in as a non-bananatag email,
    // the identifier will be replaced to represent a bananatag employee.
    const isBananatagSupport = user?.isIPFromBananaTagOffice && !user?.email.includes('@bananatag');
    const name = isBananatagSupport ? 'Bananatag Support' : `${user?.firstName} ${user?.lastName}`;

    return (
        <>
            {user && (
                <Styled.OverlayContainer
                    // @ts-ignore
                    backgroundColor={overlayBackgroundColor}
                    showStacked={showStacked}
                    borderColor={overlayBorderColor}
                    data-for={`${elmIdx}-remote`}
                    data-tip
                    ref={overlayRef}
                >
                    {showName && (
                        <Styled.UserNameBackground
                            // @ts-ignore
                            hasLogo={isBananatagSupport}
                            backgroundColor={overlayTextBackgroundColor}
                        >
                            {isBananatagSupport && (
                                <Styled.UserNameLogo src={imageSources.BANANATAG_LOGO_TRANSPARENT} />
                            )}
                            <Styled.UserNameText
                                // @ts-ignore
                                textColor={overlayTextColor}
                                backgroundColor={overlayTextBackgroundColor}
                            >
                                {name}
                            </Styled.UserNameText>
                        </Styled.UserNameBackground>
                    )}
                    <Styled.WaveContainer>
                        <Styled.WaveDot color={overlayWaveColor} />
                        <Styled.WaveDot color={overlayWaveColor} />
                        <Styled.WaveDot color={overlayWaveColor} />
                    </Styled.WaveContainer>
                    <ReactTooltip id={`${elmIdx}-remote`} place="bottom" effect="solid">
                        {`${name} is editing this element.`}
                    </ReactTooltip>
                </Styled.OverlayContainer>
            )}
            {children}
        </>
    );
};

export default RemoteUserOverlay;
